import { render, staticRenderFns } from "./wxModal.vue?vue&type=template&id=6e926a02&scoped=true&"
import script from "./wxModal.vue?vue&type=script&lang=js&"
export * from "./wxModal.vue?vue&type=script&lang=js&"
import style0 from "./wxModal.vue?vue&type=style&index=0&id=6e926a02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e926a02",
  null
  
)

export default component.exports